import { Country } from '../constants';
export function checkIsAvailableCountyCode(input) {
    return input in Country;
}
